import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/about-us")({
  head: () => buildRouteHead("/about-us", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/about-qbd", replace: true });
  },
});
